<template>
  <div>
    <b-list-group v-if="configuration" flush>
      <b-list-group-item class="p-0 border-0 bg-transparent" v-for="link in sortedConfigurationLinks" :key="link.id">
        <b-button class="pt-3 pb-3 border-0 bg-transparent"
          :class="sidebarLinksClasses(link)"
          :style="sidebarLinksStyles(link)"
          variant="dark" block @click="linkClicked(link)">
          <b-img :src="link.image.path" class="mb-2" fluid v-if="link.image"></b-img>
          <div>{{ link.name }}</div>
        </b-button>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  name: 'KioskLinks',

  data () {
    return {
      activeLinkId: undefined
    }
  },

  props: {
    configuration: {
        type: Object,
        default: undefined
    }
  },

  computed: {
    configurationLinks () {
      return this.configuration.links
    },

    sortedConfigurationLinks () {
      return this.lodash.orderBy(this.configurationLinks, ['position'], ['asc'])
    },

    defaultConfigurationLink () {
      for (var i in this.configurationLinks) {
        if (this.configurationLinks[i].is_default) {
          return this.configurationLinks[i]
        }
      }

      return null
    }
  },

  methods: {
    linkClicked (link) {
      this.activeLinkId = link.id
      this.$emit('link-clicked', link)
    },

    sidebarLinksClasses (link) {
      const classes = []

      if (!this.activeLinkId && this.defaultConfigurationLink && this.defaultConfigurationLink.id === link.id) {
        classes.push('active')
      }

      classes.push('font-weight-' + (this.configuration.sidebar_links_font_weight || 'normal'))

      return classes.join(' ')
    },

    sidebarLinksStyles () {
      const styles = []

      if (this.configuration.sidebar_links_font_size) {
        styles.push(
          'font-size: {fontSize}'.replace('{fontSize}', this.configuration.sidebar_links_font_size)
        )
      }

      return styles.join('; ')
    }
  },

  created () {
    if (this.defaultConfigurationLink) {
      this.linkClicked(this.defaultConfigurationLink)
    }
  }
}
</script>

<style>
  .list-group-item,
  .btn {
    border-radius: 0 !important;
  }

  .btn:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  .btn.active {
    background-color: rgb(0, 0, 0, 0.3) !important;
  }
</style>
